module.exports = __webpack_public_path__ + "static/media/styledDatepicker-Chevrom-Right.2a8b62b0.svg";